import {
  faBars,
  faSearch,
  faAngleDown,
  faAngleUp,
  faUserCircle,
  faUsers,
  faBriefcase,
  faFileInvoice,
  faFileImport,
  faPlusCircle,
  faAddressBook,
  faSignOutAlt,
  faShip,
  faShippingFast,
  faBook,
  faArrowCircleRight,
  faArrowCircleLeft,
  faArrowCircleUp,
  faArrowCircleDown,
  faCircle,
  faList,
  faChevronLeft,
  faChevronRight,
  faSave,
  faTimesCircle,
  faHome,
  faEdit,
  faChevronDown,
  faMinusCircle,
  faInfoCircle,
  faSyncAlt,
  faTruck,
  faPrint,
  faCogs,
  faCog,
  faTh,
  faUsdCircle,
  faClock as faClockRegular,
  faSignIn,
  faCloudUpload,
  faTachometer,
  faTachometerSlowest,
  faTachometerSlow,
  faTachometerAverage,
  faTachometerFast,
  faTachometerFastest,
  faTachometerAlt,
  faTachometerAltSlowest,
  faTachometerAltSlow,
  faTachometerAltAverage,
  faTachometerAltFast,
  faTachometerAltFastest
} from '@fortawesome/pro-regular-svg-icons';
import {
  faTrashAlt
} from '@fortawesome/pro-solid-svg-icons';

import {
  faTimes,
  faClock,
  faCalendarAlt,
  faCheckCircle,
  faCheckSquare,
  faMapMarkerAlt,
  faExclamationCircle,
  faTrash as faTrashLight,
  faTrashAlt as faTrashAltLight,
  faEdit as faEditLight, faFilePdf
} from '@fortawesome/pro-light-svg-icons';

export class FontAwesomeService {
  // regular
  public faBars = faBars;
  public faSearch = faSearch;
  public faAngleDown = faAngleDown;
  public faAngleUp = faAngleUp;
  public faUserCircle = faUserCircle;
  public faUsers = faUsers;
  public faBriefcase = faBriefcase;
  public faFileInvoice = faFileInvoice;
  public faFileImport = faFileImport;
  public faPlusCircle = faPlusCircle;
  public faAddressBook = faAddressBook;
  public faSignOutAlt = faSignOutAlt;
  public faShip = faShip;
  public faShippingFast = faShippingFast;
  public faBook = faBook;
  public faArrowCircleRight = faArrowCircleRight;
  public faArrowCircleLeft = faArrowCircleLeft;
  public faCircle = faCircle;
  public faMapMarkerAlt = faMapMarkerAlt;
  public faList = faList;
  public faCloudUpload = faCloudUpload;
  public faTrashAlt = faTrashAlt;
  public faTrashLight = faTrashLight;
  public faTrashAltLight = faTrashAltLight;
  public faCheckSquare = faCheckSquare;
  public faChevronLeft = faChevronLeft;
  public faChevronRight = faChevronRight;
  public faSave = faSave;
  public faTimesCircle = faTimesCircle;
  public faHome = faHome;
  public faEdit = faEdit;
  public faEditLight = faEditLight;
  public faChevronDown = faChevronDown;
  public faMinusCircle = faMinusCircle;
  public faInfoCircle = faInfoCircle;
  public faSyncAlt = faSyncAlt;
  public faArrowCircleUp = faArrowCircleUp;
  public faArrowCircleDown = faArrowCircleDown;
  public faTruck = faTruck;
  public faPrint = faPrint;
  public faTh = faTh;
  public faClockRegular = faClockRegular;
  public faUsdCircle = faUsdCircle;
  public faSignIn = faSignIn;
  public faTachometer = faTachometer;
  public faTachometerSlowest = faTachometerSlowest;
  public faTachometerSlow = faTachometerSlow;
  public faTachometerAvarage = faTachometerAverage;
  public faTachometerFast = faTachometerFast;
  public faTachometerFastest = faTachometerFastest;
  public faTachometerAlt = faTachometerAlt;
  public faTachometerAltSlowest = faTachometerAltSlowest;
  public faTachometerAltSlow = faTachometerAltSlow;
  public faTachometerAltAvarage = faTachometerAltAverage;
  public faTachometerAltFast = faTachometerAltFast;
  public faTachometerAltFastest = faTachometerAltFastest;
  // light
  public faTimes = faTimes;
  public faClock = faClock;
  public faCalendarAlt = faCalendarAlt;
  public faCheckCircle = faCheckCircle;
  public faCogs = faCogs;
  public faCog = faCog;
  public faExclamationCircle = faExclamationCircle;
  public faFilePdf = faFilePdf;

}



// WEBPACK FOOTER //
// ./src/app/services/font-awesome.service.ts